
import { ErrorHandler as NgErrorHandler, Injectable } from '@angular/core';

@Injectable()
export class ErrorHandler implements NgErrorHandler {
  handleError(error: any): void {
    const chunkFailedMessage = /Loading chunk (.+) failed/;

    if (chunkFailedMessage.test(error.message)) {
      window.location.reload();

      return;
    }

    console.error(error);
  }
}
